import React, { useState, useEffect } from "react";
import { Grid, Menu, Segment } from "semantic-ui-react";
import { browserHistory } from "react-router";
import Navigation from "../../components/olympus/components/Navigation";
import Footer from "../../components/olympus/components/Footer";

const BrowseView = ({ bus, children }) => {
    const [activeItem, setActiveItem] = useState(window.location.pathname);

    useEffect(() => {
        setActiveItem(window.location.pathname);
    }, []);

    const handleItemClick = (e, { value }) => {
        setActiveItem(value);
        browserHistory.push(value);
    };

    return (
        <div>
            <Navigation bus={bus} />
            <Grid columns={1} padded={true} style={{ paddingBottom: "30vh" }}>
                <Grid.Column className="noVerticalPadding">
                    <Menu pointing secondary className="ubuntuFont">
                        <Menu.Item
                            name="Genres"
                            value="/browse"
                            active={activeItem === "/browse"}
                            onClick={handleItemClick}
                        />
                        <Menu.Item
                            name="Duets"
                            value="/browse/duets"
                            active={activeItem === "/browse/duets"}
                            onClick={handleItemClick}
                        />
                        <Menu.Item
                            name="Ensembles"
                            value="/browse/ensembles"
                            active={activeItem === "/browse/ensembles"}
                            onClick={handleItemClick}
                        />
                        <Menu.Item
                            name="List"
                            value="/browse/list"
                            active={activeItem === "/browse/list"}
                            onClick={handleItemClick}
                        />
                    </Menu>
                    <Segment>{children}</Segment>
                </Grid.Column>
            </Grid>
            <Footer />
        </div>
    );
};

export default BrowseView;
